export const savePdf = async (data, filename) => {
  try {
    // Create a URL for the blob
    const blob = new Blob([data], { type: "application/pdf" });
    const downloadUrl = window.URL.createObjectURL(blob);

    // Create a link element to trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Clean up
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};
